/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     MyPlan
//   Details:    My Plan compoment
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 103839 06/04/20 JC  M01  React upgrade
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Checkbox extends Component {
	constructor(props) {
		super(props);

		this.state = { checked: this.props.checked };

		this.handleChecked = this.handleChecked.bind(this);
	}

    //M01
	//componentWillReceiveProps(nextProps) {
	//	if (nextProps.checked !== this.state.checked)
	//		this.setState({ checked: nextProps.checked });
 //   }

    //M01
    static getDerivedStateFromProps(props, state) {

        //changed?
        if (props.checked !== state.checked) {

            //return new state
            return {
                checked: props.checked
            };
        }

        // Return null to indicate no change to state.
        return null;
    }

	handleChecked = event => {
		//event.preventDefault();
		this.props.changed({ itemId: this.props.itemId, checked: !this.state.checked });
	}

	render() {
		const { name, disabled } = this.props;
		const { checked } = this.state;

		return (
			<div>
				<label>
					<input
						type="checkbox"
						name={name}
						checked={checked}
						onChange={this.handleChecked}
						value="true"
						disabled={disabled}
					/>
					{name}
				</label>
			</div>
		);
	}
}

Checkbox.propTypes = {
	type: PropTypes.string,
	name: PropTypes.string.isRequired,
	checked: PropTypes.bool,
	changed: PropTypes.func.isRequired,
	itemId: PropTypes.number
};

export default Checkbox;